import clx from 'classnames';
import { PropsWithChildren } from 'react';

const Quote = ({ children, className }: PropsWithChildren<{ className?: string }>) => (
  <div className={clx('text-center', className)}>
    <p className="text-neutral-900 title-4 px-1 leading-8 before:content-['“'] after:content-['”']">{children}</p>
  </div>
);

export default Quote;
